import React from "react";
function IntegrationwithSafexpay() {
  return (
    <div class="idocs-content">
      <div class="container">
        <div class="row">
          <div class="col-md-8">
            <section id="idocs_content" class="mt-20 mb-20">
              <h1> Integration with Safexpay </h1>
              <hr />
            </section>

            <p className="para-blod"> Set-Up :</p>

            <p>
              <b>Safexpay</b> will share the “Integration kit” with respect to
              your website’s programming language via email.
            </p>

            <p>
              You must implement the Safexpay transaction files on your server
              to initiate the payment process with the help of the Test Merchant
              ID and key to check the entire Transaction flow in our UAT/Test
              Environment.
            </p>

            <p>
              Please refer to the Configure part below to integrate the website
              with the Payment page.
            </p>

            <p className="para-blod">Configure :</p>

            <p>
              Once the testing is done, <b>Safexpay</b> provides the Login
              credentials of the <b>Safexpay</b> portal.
            </p>

            <p>
              Once the login is done successfully, the Merchant receives a
              unique set of keys (Merchant ID and Merchant Key) for transaction
              processing; these need to be configured in the transaction file
              used to initiate the payment process.
            </p>

            <p className="para-blod">
              Login to Portal --- Click on the Top right-hand side --- Click on
              User Profile --- Copy the Merchant ID and Merchant Key.
            </p>

            <p className="para-blod">Payment Processing</p>

            <p>
              To initiate the payment process, you must post the required
              transaction details through the <b>Safexpay</b> transaction file (e.g.,
              index.php). Encrypt the transaction request and send it to the <b>Safexpay</b> Payment Page.
            </p>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
  );
}
export default IntegrationwithSafexpay;
